<template>
  <form-layout class="form-layout">
    <span slot="title">调度申请单</span>
    <el-form :model="ruleForm" ref="ruleForm" :rules="rules" slot="apply-box" :inline="true">
      <el-form-item label="出库地" prop="OutLibrary">
        <el-select class="form-input" v-model="ruleForm.OutLibrary" placeholder="请选择出库地">
          <el-option
            v-for="item in warehouses"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="入库地" prop="InLibrary">
        <el-select class="form-input" v-model="ruleForm.InLibrary" placeholder="请选择入库地">
          <el-option
            v-for="item in warehouses"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物流类型" prop="Logisticstype">
        <el-select class="form-input" v-model="ruleForm.Logisticstype" placeholder="请选择物流类型">
          <el-option
            v-for="item in LogisticsType"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>  
      </el-form-item>
      <br>
      <el-form-item label="调度备注">
        <el-input type="textarea" style="width:600px;" class="form-input" v-model="ruleForm.notes" placeholder="调度备注"></el-input>
      </el-form-item>
    </el-form>
    <div class="table_area" slot="main-content">
      <div class="item-box" v-for="(item, index) in managedbox">
        <table>
          <thead>
            <tr>
              <td width="260">物料名称</td>
              <td width="120">品项</td>
              <td width="100">品牌</td>
              <td width="100">机型</td>
              <td>模块</td>
              <td>区域</td>
              <td>库存</td>
              <td>调度数量</td>
            </tr>
          </thead>
          <tbody>
            <tr >
              <td>
                {{item.ProductName}}<br>
                物料编码：{{item.ProductCode}}
              </td>
              <td>
                <el-tag :type="item.ConditionName | ConditionColor">{{item.ConditionName}}</el-tag>
              </td>
              <td>
                {{item.ProductBrandName}}
              </td>
              <td>
                {{item.ProductModelName}}
              </td>
              <td>
                {{item.ProductModuleName}}
              </td>
              <td>{{item.RegionName}}</td>
              <td>
                {{item.Quantity}}
              </td>
              <td>
                <el-input-number placeholder="数量" :min="1" :max="item.Quantity" v-model.number="item.SendQuantity"></el-input-number>
              </td>
            </tr>
          </tbody>
        </table>
        <el-button class="delete-btn" @click.native="deleteItem(index)">X</el-button>
      </div>
    </div>
    <div class="sumbit_box" slot="sumbit_box">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click.native="sumbit">提交并等待客服联系</el-button>
    </div>
  </form-layout>
</template>

<script>
import FormLayout from '@/components/pages/Inventory/FormLayout'
import AddressBox from '@/components/common/Address'
import o from '@/odata'
import { Loading } from 'element-ui'
export default {
  data() {
    return {
      ruleForm: {
        OutLibrary: null,
        InLibrary: null,
        Logisticstype: null,
        notes: null,
      },
      rules: {
        OutLibrary: [{required: true, message: '必填'}],
        InLibrary: [{required: true, message: '必填'}],
        Logisticstype: [{required: true, message: '必填'}],
      },
      LogisticsType: [
        {label: '森普瑞物流', value: 'internal'},
        {label: '第三方物流', value: 'external'},
        {label: '自提', value: 'none'},
      ],
      warehouses: [],
      Regions: [],
      warehouseDate: '',
      tableData: [],
      managedbox: [],
    }
  },
  methods: {
    deleteItem: function(index, item) {
      this.$confirm('是否确认删除?', '删除批次', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.managedbox.splice(index, 1)
        window.localStorage.setItem('managedbox', JSON.stringify(this.managedbox))
        this.$message({
          type: 'success',
          message: '删除成功!',
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除',
        })
      })
    },
    sumbit: function() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.sendform = []
          let loading = Loading.service({text: '正在提交订单,请稍后', customClass: 'comfirmLoading'})
          for (var a = 0; a < this.managedbox.length; a++) {
            this.sendform.push({
              ProductId: this.managedbox[a].ProductId,
              ConditionId: this.managedbox[a].ConditionId,
              Quantity: this.managedbox[a].SendQuantity,
            })
          }
          const RepairOrder = o('ProcurementApOrder')
          const form = {
            OrderType: 'instant',
            ProcurementType: 'one_to_one',
            PrincipalId: 1,
            PartnerId: 1,
            ExpressCompanyId: 1,
            ShipmentMethod: this.ruleForm.Logisticstype,
            SourceWarehouseId: this.ruleForm.OutLibrary,
            DestinationWarehouseId: this.ruleForm.InLibrary,
            Notes: this.ruleForm.notes,
            Lines: this.sendform,
          }
          RepairOrder.post(form).save().then((data) => {
            this.$message({
              message: '提交成功',
              type: 'success',
            })
            this.managedbox = []
            window.localStorage.setItem('dispatchbox', JSON.stringify(this.dispatchbox))
            // this.$router.push('/trust')
            this.$router.push('/dispatch_order')
            loading.close()
          }).catch(() => {
            loading.close()
            if (form.RepairType === '' || form.PartnerId === '') {
              this.$message({
                message: '提交失败, 不能为空',
                type: 'info',
              })
            } else {
              this.$message({
                message: '提交失败,请填写完整信息',
                type: 'info',
              })
            }
          })
        } else {
          this.$message({
            message: '请填写必填内容',
            type: 'warning',
          })
        }
      })
    },
    cancel: function() {
      // 根据跳转之前的页面,跳转回对应的页面
      const managedApplyFlag = window.localStorage.getItem('managedApplyFlag')
      if (managedApplyFlag === 'trustListPage') {
        // 跳转至委托库查询-自己委托库
        window.localStorage.setItem('trustListFlag', 'self')
        window.localStorage.setItem('managedApplyFlag', '')
        this.$router.push('/trust')
      } else {
        // 跳转至代管库查询-自有代管库
        window.localStorage.setItem('orderUrl', 'entrustOrder')
        this.$router.push('/managed')
      }
    },
    initManaged: function() {
      this.managedbox = JSON.parse(window.localStorage.getItem('managedbox'))
      // for (var a = 0; a < this.managedbox.length; a++) {
      //   this.managedbox[a].Quantity = 1
      // }
    },
    initWarehouse: function() {
      let loading = Loading.service({text: '加载中'})
      const Warehouse = o('Warehouse')
      Warehouse.get().then((response) => {
        this.warehouses = response.data
        loading.close()
      }).catch(() => {
        loading.close()
      })
    },
  },
  components: {
    FormLayout,
    AddressBox,
  },
  created() {
    this.initManaged()
    this.initWarehouse()
  },
}
</script>

<style lang="less" scoped>
.form-input {
  width: 260px;
}
.list-layout .complex-table .sub-row-table .sub-body .text-center{
  border-right: 1px solid #dfe6ec;
  border-bottom: 1px solid #dfe6ec;
}
.main-content{
  .tab{
    .el-tabs__active-bar{
      background-color: rgba(0,0,0,0);
    }
  }
}
.add-btn:hover,.add-btn:focus{
  color: #FFFFFF;
  background: #2283CA;
}
.item-box{
  position: relative;
  padding: 20px;
  background-color: #fff;
  margin-bottom: 25px;
  border: 1px solid #E1E8EE;
  width: 90%;
  .el-select,.el-input{
    width: 100%;
  }
  .delete-btn{
    position: absolute;
    right: -60px;
    top: 35%;
    background-color: #FF4949;
    color: #fff;
    padding: 10px 12px;
    border-radius: 50%;
    border: none;
  }
  table{
    display: inline-block;
    label{
      display: block;
      margin-bottom: 5px;
    }
    td{
      padding-right: 20px;
    }
    td:last-child{
      padding-right: 0;
    }
  }
}
.sumbit_box{
  margin-top: 20px;
  text-align: right;
  p{
    text-align: right;
    font-size: 18px;
    color:  #1F2D3D;
    span{
      color: #FF4949;
    }
  }
  .el-button {
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// ManagedApplyPage.vue?017ac2d9